import Vue from 'vue'
import { arrayFind } from 'util/ts-utils'
import { callTurnToConfigFn } from 'util/turnto-utils'
import logger from 'util/logger'
import globalStore from 'init/global-store'
import apiService, { RestError, SummaryDimension, SubdimensionTeaserConfig }
  from 'services/api-service'
import DimDistribution from 'components/reviews-summary/dim-distribution'
import SummaryDimRange from 'components/reviews-summary/summary-dim-range'

import withRender from './subdimension-teaser.html'
import './subdimension-teaser.scss'


export default withRender(Vue.extend({
  name: 'SubdimensionTeaser',
  data() {
    return {
      customDimensions: [],
      globalStore,
      hide: false
    }
  },
  props: {
    // since there can be multiple subdimension teasers per page, the config is passed in
    teaserConfig: Object
  },
  components: {
    'tt-summary-custom-range': SummaryDimRange,
    'tt-dim-distribution': DimDistribution
  },
  computed: {
    currentSku(): string {
      return this.globalStore.sku
    },
    subdims() {
      return (this.teaserConfig as SubdimensionTeaserConfig).subdimensions.map((dimConfig) => {
        const customDim = arrayFind(this.customDimensions, (dim: SummaryDimension) => {
          return dim.dimensionDefinitionId === dimConfig.dimId
        }) as SummaryDimension
        const totalReviewsForDim =
          customDim ? customDim.values.reduce((sum, b) => sum + b.count, 0) : 0
        return totalReviewsForDim < this.teaserConfig.minReviews ? undefined : {
          dim: customDim,
          label: customDim.teaserLabel || customDim.label,
          displayType: dimConfig.displayType,
          numReviewsMsg: this.$msg(
            'dimTeaser.reviews', [totalReviewsForDim], totalReviewsForDim
          )
        }
      }).filter(subDim => subDim !== undefined)
    }
  },
  methods: {
    fetchData() {
      if (this.currentSku) {
        apiService.reviewsSummary({
          sku: this.currentSku
        }).then((data) => {
          if (!data) { // invalid sku most likely
            return
          }
          this.customDimensions = data.customDimensions
          this.hide = data.hideDisplay
          this.$nextTick(() => { callTurnToConfigFn('subdimensionTeaser', 'onFinish') })
        }).catch((e: RestError) => {
          if (e.errorCode === 'turnto-offline') {
            logger.info('TurnTo is in offline mode - Reviews Summary not loaded', e)
          } else {
            logger.error('Error loading data for the Reviews Summary widget', e)
          }
        })
      }
    }
  },
  watch: {
    // whenever the currentSku changes, we need to reload the comments
    currentSku() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/subdimension-teaser/subdimension-teaser.ts